export default function oldDataList(){
    return(
        [
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB001",
                    "brand": "Lenovo",
                    "seNo": "R0AHSBR",
                    "model": "ThinkPad TP 13 G2",
                    "description": "Bundle with Bag and Mouse (GLEC-NB001M)",
                    "purchaseDate": "2018-1-17",
                    "purchaseValue": "1580",
                    "warrantyDueDate": "2021-1-16",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lim Sing Tian",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2021-8-3",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-8-3",
                        "returnDate": "2021-8-3",
                    },
                    {
                        "user": "Lim Sing Tian",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2021-8-3",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB029",
                    "brand": "Lenovo",
                    "seNo": "",
                    "model": "ThinkPad E480",
                    "description": "Bundle with Bag and Mouse (GLEC-NB029M)",
                    "purchaseDate": "2019-4-1",
                    "purchaseValue": "1499",
                    "warrantyDueDate": "2022-4-1",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Raymond Gan Chun Pin",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2021-8-17",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-8-17",
                        "returnDate": "2021-8-17",
                    },
                    {
                        "user": "Raymond Gan Chun Pin",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2021-8-17",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB059",
                    "brand": "ASUS",
                    "seNo": "MCNXCV07T748496",
                    "model": "B9400CEA-KC1255X",
                    "description": "Includes charging cable, slim carrying case",
                    "purchaseDate": "2022-7-5",
                    "purchaseValue": "1700",
                    "warrantyDueDate": "2024-12-13",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Raymond Gan Chun Pin",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-8-8",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-8-8",
                        "returnDate": "2022-8-8",
                    },
                    {
                        "user": "Raymond Gan Chun Pin",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-8-8",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB003",
                    "brand": "Lenovo",
                    "seNo": "PF10NMRW",
                    "model": "ThinkPad E470",
                    "description": "Bundle with Bag and Mouse (GLEC-NB003M)",
                    "purchaseDate": "2018-1-23",
                    "purchaseValue": "1280",
                    "warrantyDueDate": "2021-1-22",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lim Sock Kiang",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2021-3-8",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-3-8",
                        "returnDate": "2021-3-8",
                    },
                    {
                        "user": "Lim Sock Kiang",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2021-3-8",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB004A",
                    "brand": "ASUS",
                    "seNo": "R2NXCV05F636074",
                    "model": "ASUS B9400CBA-KC0227X",
                    "description": "WIth laptop bag , Mouse ,charger and laptop dongle",
                    "purchaseDate": "2023-8-18",
                    "purchaseValue": "2187",
                    "warrantyDueDate": "2024-8-18",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lim Sock Peck",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-8-25",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-8-25",
                        "returnDate": "2023-8-25",
                    },
                    {
                        "user": "Lim Sock Peck",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-8-25",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM004A",
                    "brand": "Acer",
                    "seNo": "6604029419600",
                    "model": "Acer Veriton M2640 Tower ",
                    "description": "Intel Core I5-6500, Windows 7 Professional, Harddisk, DVD drive",
                    "purchaseDate": "2016-10-25",
                    "purchaseValue": "950",
                    "warrantyDueDate": "2017-10-25",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lim Sock Peck",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-06",
                        "returnDate": "2023-12-06",
                    },
                    {
                        "user": "Lim Sock Peck",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB064",
                    "brand": "Asus",
                    "seNo": "R6NXNZ00R53625A",
                    "model": "B1400CBA-EB1395X",
                    "description": "With Laptop bag, mouse and charger",
                    "purchaseDate": "2023-12-08",
                    "purchaseValue": "1193",
                    "warrantyDueDate": "2026-12-08",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lam Sook Mun",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-08-24",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-08-24",
                        "returnDate": "2023-08-24",
                    },
                    {
                        "user": "Lam Sook Mun",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-08-24",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB023",
                    "brand": "Lenovo",
                    "seNo": "PF1E68YS",
                    "model": "ThinkPad E490S",
                    "description": "Bundle with Bag and Mouse(GLEC-NB023M)",
                    "purchaseDate": "2019-10-29",
                    "purchaseValue": "1174",
                    "warrantyDueDate": "2022-10-28",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Chee Kwok Sing, Clement",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2021-03-08",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-03-08",
                        "returnDate": "2021-03-08",
                    },
                    {
                        "user": "Chee Kwok Sing, Clement",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2021-03-08",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM020",
                    "brand": "DELL",
                    "seNo": "CN-008WTP",
                    "model": "TV200",
                    "description": "24 INCH Monitor with Webcam ",
                    "purchaseDate": "2020-06-08",
                    "purchaseValue": "350",
                    "warrantyDueDate": "2021-06-08",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lim Sing Tian",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-06",
                        "returnDate": "2023-12-06",
                    },
                    {
                        "user": "Lim Sing Tian",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB021A",
                    "brand": "LG",
                    "seNo": "004NTKFG637",
                    "model": "LG",
                    "description": "LG Monitor",
                    "purchaseDate": "2016-09-07",
                    "purchaseValue": "180",
                    "warrantyDueDate": "2017-09-07",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Raymond Gan Chun Pin",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-06",
                        "returnDate": "2023-12-06",
                    },
                    {
                        "user": "Raymond Gan Chun Pin",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM019",
                    "brand": "LG",
                    "seNo": "004NTKFGF637",
                    "model": "27MK430H 27INCH Class Full HD IPS LED",
                    "description": "27INCH LG Monitor",
                    "purchaseDate": "2020-06-23",
                    "purchaseValue": "278",
                    "warrantyDueDate": "2021-06-23",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Raymond Gan Chun Pin",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-06",
                        "returnDate": "2023-12-06",
                    },
                    {
                        "user": "Raymond Gan Chun Pin",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM016",
                    "brand": "ACER",
                    "seNo": "000",
                    "model": "21INCH Monitor",
                    "description": "",
                    "purchaseDate": "2017-01-01",
                    "purchaseValue": "150",
                    "warrantyDueDate": "2018-01-01",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lim Sock Peck",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2018-01-01",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2018-01-01",
                        "returnDate": "2018-01-01",
                    },
                    {
                        "user": "Lim Sock Peck",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2018-01-01",
                        "returnDate": "2018-01-01",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM27001",
                    "brand": "Acer",
                    "seNo": "MMT0YSG0027107B11C4210",
                    "model": "Acer G277HL ",
                    "description": "27 inch Wide IPS Panel Monitor Ports AvailableCOLON VGA, DVI, HDMI",
                    "purchaseDate": "2017-05-04",
                    "purchaseValue": "279",
                    "warrantyDueDate": "2018-05-03",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lam Sook Mun",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2021-03-08",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-03-08",
                        "returnDate": "2021-03-08",
                    },
                    {
                        "user": "Lam Sook Mun",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2021-03-08",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM004B",
                    "brand": "Acer",
                    "seNo": "00161106B694220",
                    "model": "Acer 19.5 inch Monitor",
                    "description": "",
                    "purchaseDate": "2016-10-25",
                    "purchaseValue": "130",
                    "warrantyDueDate": "2017-10-25",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Chee Kwok Sing, Clement",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-06",
                        "returnDate": "2023-12-06",
                    },
                    {
                        "user": "Chee Kwok Sing, Clement",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM27002",
                    "brand": "Acer",
                    "seNo": "71050409342",
                    "model": "Acer G277HL",
                    "description": "27 inch Wide IPS Panel Monitor Ports AvailableCOLON VGA, DVI, HDMI",
                    "purchaseDate": "2017-05-04",
                    "purchaseValue": "279",
                    "warrantyDueDate": "2018-05-03",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "How Siew Peng",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2021-03-08",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-03-08",
                        "returnDate": "2021-03-08",
                    },
                    {
                        "user": "How Siew Peng",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2021-03-08",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DT007A",
                    "brand": "Lenovo",
                    "seNo": "DC1121100755103AE3K701",
                    "model": "T2224D",
                    "description": "21.5 inch Monitor (VGA + DP)",
                    "purchaseDate": "2019-04-01",
                    "purchaseValue": "180",
                    "warrantyDueDate": "2020-04-01",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "How Siew Peng",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-05-08",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-05-08",
                        "returnDate": "2023-05-08",
                    },
                    {
                        "user": "How Siew Peng",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-05-08",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB055",
                    "brand": "ASUS",
                    "seNo": "LANXCV07A590426",
                    "model": "Asus AP2451FA-EK0888R",
                    "description": "Issue only Laptop and Cable",
                    "purchaseDate": "2021-02-08",
                    "purchaseValue": "1500",
                    "warrantyDueDate": "2024-02-07",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lee Ping Han",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2021-03-08",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-03-08",
                        "returnDate": "2021-03-08",
                    },
                    {
                        "user": "Lee Ping Han",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2021-03-08",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB046",
                    "brand": "Acer",
                    "seNo": "NXHMFSG00L952026492N00",
                    "model": "Aspire 5-A514-52-58BS",
                    "description": "Bundle with Bag and Mouse (GLEC-NB046M)",
                    "purchaseDate": "2020-02-11",
                    "purchaseValue": "976",
                    "warrantyDueDate": "2024-02-10",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Wang Poh Ling",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2022-04-04",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-04-04",
                        "returnDate": "2022-04-04",
                    },
                    {
                        "user": "Wang Poh Ling",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2022-04-04",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM015A",
                    "brand": "Lenovo",
                    "seNo": "VKAR7202",
                    "model": "ThinkVision E2054 - Type 60DF ",
                    "description": "Bundle with GLEC-DT015",
                    "purchaseDate": "2020-01-08",
                    "purchaseValue": "130",
                    "warrantyDueDate": "2021-01-08",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Wang Poh Ling",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-06",
                        "returnDate": "2023-12-06",
                    },
                    {
                        "user": "Wang Poh Ling",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB062",
                    "brand": "Asus",
                    "seNo": "R1NXNZ00661102C",
                    "model": "ASUS EXPERTBOOK B1400CBA-EB0219X",
                    "description": "Come withCOLON Changer, mouse, laptop bag",
                    "purchaseDate": "2023-02-17",
                    "purchaseValue": "1625",
                    "warrantyDueDate": "2024-02-17",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lim Meng Meng",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-03-22",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-03-22",
                        "returnDate": "2023-03-22",
                    },
                    {
                        "user": "Lim Meng Meng",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-03-22",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB068",
                    "brand": "Asus",
                    "seNo": "R6NXNZ00R754251",
                    "model": "ASUS EXPERTBOOK B1400CBA-EB0219X",
                    "description": "with Laptop bag , mouse and Charger",
                    "purchaseDate": "2023-09-08",
                    "purchaseValue": "1193",
                    "warrantyDueDate": "2024-09-08",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Yvette Hu MingMei",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-09-25",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-09-25",
                        "returnDate": "2023-09-25",
                    },
                    {
                        "user": "Yvette Hu MingMei",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-09-25",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB012",
                    "brand": "Asus",
                    "seNo": "KBNXCV15N136486",
                    "model": "Asus P1440FB-FA0090R",
                    "description": "Bundle with Bag",
                    "purchaseDate": "2020-02-19",
                    "purchaseValue": "1400",
                    "warrantyDueDate": "2021-02-19",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Chong Chen Hung",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-08-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-08-30",
                        "returnDate": "2023-08-30",
                    },
                    {
                        "user": "Chong Chen Hung",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-08-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB052",
                    "brand": "ASUS",
                    "seNo": "LCNXCV02H223499",
                    "model": "Asus ExpertBook P2451FB-EK0107R",
                    "description": "Bundle with Bag and Mouse (GLEC-NB052M)",
                    "purchaseDate": "2021-02-02",
                    "purchaseValue": "1500",
                    "warrantyDueDate": "2022-02-02",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Su Sandi Aung",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-11-10",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-11-10",
                        "returnDate": "2023-11-10",
                    },
                    {
                        "user": "Su Sandi Aung",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-11-10",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM073",
                    "brand": "ASUS",
                    "seNo": "R8LMTF164477",
                    "model": "ASUS VA24EHFFHD",
                    "description": "PS1MPRT (VT) 100HZ EYE CARE",
                    "purchaseDate": "2023-11-29",
                    "purchaseValue": "130",
                    "warrantyDueDate": "2024-11-29",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "ArunKumar Ganapathypalayam Mani",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2024-01-12",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2024-01-12",
                        "returnDate": "2024-01-12",
                    },
                    {
                        "user": "ArunKumar Ganapathypalayam Mani",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2024-01-12",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB073",
                    "brand": "ASUS",
                    "seNo": "R9NXCV09E05537D",
                    "model": "ASUS B1402CVA-EB0123X",
                    "description": "Bundle with Bag and Mouse (GLEC-NB073M and GLEC-DM073)",
                    "purchaseDate": "2023-12-13",
                    "purchaseValue": "1193",
                    "warrantyDueDate": "2024-12-13",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "ArunKumar Ganapathypalayam Mani",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2024-01-12",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2024-01-12",
                        "returnDate": "2024-01-12",
                    },
                    {
                        "user": "ArunKumar Ganapathypalayam Mani",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2024-01-12",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB045",
                    "brand": "Asus",
                    "seNo": "KANXCV09Z50442D",
                    "model": "AsusPro P1440FB-FA0016R",
                    "description": "Bundle with Bag and Mouse (GLEC-NB045M)",
                    "purchaseDate": "2020-01-08",
                    "purchaseValue": "1099",
                    "warrantyDueDate": "2023-01-07",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Ninonuevo Jay Jay De Guzman",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2021-04-14",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-04-14",
                        "returnDate": "2021-04-14",
                    },
                    {
                        "user": "Ninonuevo Jay Jay De Guzman",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2021-04-14",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB030",
                    "brand": "Lenovo",
                    "seNo": "PF-1MC5T1",
                    "model": "ThinkPad E480",
                    "description": "Bundle with Bag and Mouse (GLEC-MB002)",
                    "purchaseDate": "2019-04-01",
                    "purchaseValue": "1199",
                    "warrantyDueDate": "2020-04-01",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Ninonuevo Jay Jay De Guzman",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-04-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-04-06",
                        "returnDate": "2023-04-06",
                    },
                    {
                        "user": "Ninonuevo Jay Jay De Guzman",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-04-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB053",
                    "brand": "ASUS",
                    "seNo": "LANXCV07A55842B",
                    "model": "Asus AP2451FA-EK0888R",
                    "description": "Bundle with Bag and Mouse (GLEC-NB053M)",
                    "purchaseDate": "2021-02-08",
                    "purchaseValue": "1500",
                    "warrantyDueDate": "2024-02-07",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Ye Zhijiang",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2021-04-22",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-04-22",
                        "returnDate": "2021-04-22",
                    },
                    {
                        "user": "Ye Zhijiang",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2021-04-22",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB072",
                    "brand": "Asus",
                    "seNo": "R9NXCV09E061378",
                    "model": "ASUS B1402CVA-EB0123X",
                    "description": "ASUS B1402CVA-EB0123XNEWLINEP/NCOLON 90NX06W1-M004V0NEWLINEINTEL CORE I7-1335U, 1X16GB, 512GB PCIE SSD+TPM, UMA,NEWLINEWIN 11 PRO, 14INCH FHD 250NITS ANTI-GLARE DISPLAY, HDNEWLINEWEBCAM, WIFI 6, W/FINGERPRINT/BACKLIT KB, 1.49KG",
                    "purchaseDate": "2023-11-03",
                    "purchaseValue": "1193",
                    "warrantyDueDate": "2024-11-03",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Wu HongYi Edwin",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-11-22",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-11-22",
                        "returnDate": "2023-11-22",
                    },
                    {
                        "user": "Wu HongYi Edwin",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-11-22",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM27003",
                    "brand": "Samsung",
                    "seNo": "6AMXH9TWA01462",
                    "model": "S27C330GAE",
                    "description": "",
                    "purchaseDate": "2024-01-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2026-01-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Wu HongYi Edwin",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2024-01-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2024-01-30",
                        "returnDate": "2024-01-30",
                    },
                    {
                        "user": "Wu HongYi Edwin",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2024-01-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB034",
                    "brand": "Lenovo",
                    "seNo": "000",
                    "model": "ThinkPad E490",
                    "description": "Bundle with Bag and Mouse (GLEC-NB034M)",
                    "purchaseDate": "2019-07-26",
                    "purchaseValue": "1199",
                    "warrantyDueDate": "2022-07-25",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Madhanagopal Elayaraja",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2021-03-08",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-03-08",
                        "returnDate": "2021-03-08",
                    },
                    {
                        "user": "Madhanagopal Elayaraja",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2021-03-08",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB063",
                    "brand": "Asus",
                    "seNo": "000",
                    "model": "ASUS EXPERTBOOK B1400CBA-EB0219X",
                    "description": "",
                    "purchaseDate": "2023-02-17",
                    "purchaseValue": "1400",
                    "warrantyDueDate": "2024-02-17",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Salguet Gina Nabor",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-03-22",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-03-22",
                        "returnDate": "2023-03-22",
                    },
                    {
                        "user": "Salguet Gina Nabor",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-03-22",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB069",
                    "brand": "Asus",
                    "seNo": "R6NXNZ00R528257",
                    "model": "ASUS EXPERTBOOK B1400CBA-EB0219X",
                    "description": "",
                    "purchaseDate": "2023-08-09",
                    "purchaseValue": "1193",
                    "warrantyDueDate": "2024-08-09",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Mery Juana",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-09-29",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-09-29",
                        "returnDate": "2023-09-29",
                    },
                    {
                        "user": "Mery Juana",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-09-29",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM021",
                    "brand": "LG",
                    "seNo": "209NTDV4E754",
                    "model": "27MP400",
                    "description": "LG 27MP400-B Mainstream 27INCH FullNEWLINEHD IPS Display, Freesync with 75Hz,NEWLINE1x HDMI, Wall mount",
                    "purchaseDate": "2023-02-21",
                    "purchaseValue": "258.12",
                    "warrantyDueDate": "2024-02-21",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Mery Juana",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-06",
                        "returnDate": "2023-12-06",
                    },
                    {
                        "user": "Mery Juana",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DT010",
                    "brand": "Samsung",
                    "seNo": "000",
                    "model": "LED Flat Panel Monitor",
                    "description": "",
                    "purchaseDate": "2019-09-01",
                    "purchaseValue": "130",
                    "warrantyDueDate": "2020-09-01",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Dhamelia Urja Anand",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2022-03-04",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-04",
                        "returnDate": "2022-03-04",
                    },
                    {
                        "user": "Dhamelia Urja Anand",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2022-03-04",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB065",
                    "brand": "Asus",
                    "seNo": "R6NXNZ00R532255",
                    "model": "ASUS B1400CBA-EB1395X",
                    "description": "with Laptop Bag, mouse and charger ",
                    "purchaseDate": "2023-08-18",
                    "purchaseValue": "1193",
                    "warrantyDueDate": "2026-08-18",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Dhamelia Urja Anand",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-08-24",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-08-24",
                        "returnDate": "2023-08-24",
                    },
                    {
                        "user": "Dhamelia Urja Anand",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-08-24",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB057",
                    "brand": "Lenovo",
                    "seNo": "PF-3C4LRE",
                    "model": "ThinkPad E14 Gen2 ITL",
                    "description": "",
                    "purchaseDate": "2022-05-13",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-11-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Rajendran Ayyappan",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2022-08-12",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-08-12",
                        "returnDate": "2022-08-12",
                    },
                    {
                        "user": "Rajendran Ayyappan",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2022-08-12",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM005B",
                    "brand": "Lenovo",
                    "seNo": "V5F78420",
                    "model": "T2224D 21.5INCH Monitor ",
                    "description": "",
                    "purchaseDate": "2016-08-27",
                    "purchaseValue": "173",
                    "warrantyDueDate": "2017-08-27",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Rajendran Ayyappan",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-06",
                        "returnDate": "2023-12-06",
                    },
                    {
                        "user": "Rajendran Ayyappan",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DT009",
                    "brand": "Lenovo",
                    "seNo": "VKP3532562PC026",
                    "model": "ThinkCentre V530S",
                    "description": "",
                    "purchaseDate": "2019-07-26",
                    "purchaseValue": "769",
                    "warrantyDueDate": "2020-07-26",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lim Sock Peck",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-05-08",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-05-08",
                        "returnDate": "2023-05-08",
                    },
                    {
                        "user": "Lim Sock Peck",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-05-08",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM009A",
                    "brand": "Lenovo",
                    "seNo": "000",
                    "model": "ThinkVision S22E-19",
                    "description": "21.5INCH",
                    "purchaseDate": "2019-07-26",
                    "purchaseValue": "180",
                    "warrantyDueDate": "2020-07-26",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Sim Li Gek Suzie",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-06",
                        "returnDate": "2023-12-06",
                    },
                    {
                        "user": "Sim Li Gek Suzie",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB044",
                    "brand": "Asus",
                    "seNo": "KANXCV09Z50442D",
                    "model": "AsusPro P1440FB-FA0016R",
                    "description": "Bundle with Bag and Mouse (GLEC-NB044M)",
                    "purchaseDate": "2020-01-08",
                    "purchaseValue": "1099",
                    "warrantyDueDate": "2023-01-07",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Myat Noe Aung",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2022-03-09",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-09",
                        "returnDate": "2022-03-09",
                    },
                    {
                        "user": "Myat Noe Aung",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2022-03-09",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM001B",
                    "brand": "Acer",
                    "seNo": "000",
                    "model": "Acer Monitor V206HQL",
                    "description": "18INCH",
                    "purchaseDate": "2014-10-21",
                    "purchaseValue": "130",
                    "warrantyDueDate": "2015-10-21",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Myat Noe Aung",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-06",
                        "returnDate": "2023-12-06",
                    },
                    {
                        "user": "Myat Noe Aung",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB058",
                    "brand": "HP",
                    "seNo": "5CD1368Y49",
                    "model": "HP ProBook 440 G8 Notebook PC",
                    "description": "Brand New",
                    "purchaseDate": "2022-05-20",
                    "purchaseValue": "1299",
                    "warrantyDueDate": "2023-05-20",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Omit Syed Hasanuzzaman",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-11-29",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-11-29",
                        "returnDate": "2023-11-29",
                    },
                    {
                        "user": "Omit Syed Hasanuzzaman",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-11-29",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB056",
                    "brand": "Lenovo",
                    "seNo": "PF2Z10GM",
                    "model": "Lenovo ThinkPad E14 Gen2 ITL",
                    "description": "Brand New",
                    "purchaseDate": "2021-10-21",
                    "purchaseValue": "1299",
                    "warrantyDueDate": "2024-10-20",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Su May Kyaw",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2021-10-23",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-10-23",
                        "returnDate": "2021-10-23",
                    },
                    {
                        "user": "Su May Kyaw",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2021-10-23",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DM013",
                    "brand": "Lenovo",
                    "seNo": "VKP3934300PC058",
                    "model": "ThinkVision E2054",
                    "description": "19.5INCH",
                    "purchaseDate": "2019-04-01",
                    "purchaseValue": "150",
                    "warrantyDueDate": "2020-04-01",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Su May Kyaw",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-06",
                        "returnDate": "2023-12-06",
                    },
                    {
                        "user": "Su May Kyaw",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB061",
                    "brand": "Asus",
                    "seNo": "MCNXCV07F916490",
                    "model": "ASUS EXPERTBOOK B1400CBA-EB0219X",
                    "description": "Bundle with Bag and Mouse",
                    "purchaseDate": "2022-08-18",
                    "purchaseValue": "1230",
                    "warrantyDueDate": "2023-08-18",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Choy Teik Loong ",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-03-22",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-03-22",
                        "returnDate": "2023-03-22",
                    },
                    {
                        "user": "Choy Teik Loong ",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-03-22",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB035",
                    "brand": "Lenovo",
                    "seNo": "PF-1P83FL",
                    "model": "ThinkPad E490",
                    "description": "Bundle with Bag and Mouse (GLEC-NB035M)",
                    "purchaseDate": "2019-07-26",
                    "purchaseValue": "1199",
                    "warrantyDueDate": "2022-07-25",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Omit Syed Hasanuzzaman",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2021-05-07",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-05-07",
                        "returnDate": "2021-05-07",
                    },
                    {
                        "user": "Omit Syed Hasanuzzaman",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2021-05-07",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB058",
                    "brand": "HP",
                    "seNo": "5CD1368Y49",
                    "model": "HP ProBook 440 G8 Notebook PC",
                    "description": "Brand New",
                    "purchaseDate": "2022-05-20",
                    "purchaseValue": "1299",
                    "warrantyDueDate": "2023-05-20",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lim Yee Ling",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-11-29",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-11-29",
                        "returnDate": "2023-11-29",
                    },
                    {
                        "user": "Lim Yee Ling",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-11-29",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB025",
                    "brand": "Lenovo",
                    "seNo": "PF0Y0NKX",
                    "model": "ThinkPad E470",
                    "description": "Bundle with Bag and Mouse (GLEC-NB025M)",
                    "purchaseDate": "2018-08-14",
                    "purchaseValue": "1099",
                    "warrantyDueDate": "2019-08-14",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Nur Muhammad Matien Bin Kamarudin",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-03-21",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-03-21",
                        "returnDate": "2023-03-21",
                    },
                    {
                        "user": "Nur Muhammad Matien Bin Kamarudin",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-03-21",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB070",
                    "brand": "Asus",
                    "seNo": "R7NXCV123067290",
                    "model": "B1402CVA-EB0124X",
                    "description": "ASUS B1402CVA-EB0124XNEWLINEP/NCOLON 90NX06W1-M004W0NEWLINEINTEL CORE I5-1335U, 1X16GB, 512GB PCIE SSD+TPM, UMA,NEWLINEWIN 11 PRO, 14INCH FHD 250NITS ANTI-GLARE DISPLAY, HDNEWLINEWEBCAM, WIFI 6, W/FINGERPRINT/BACKLIT KB, 1.49KGNEWLINES$1,193.00 S$1,193.00NEWLINE3 YEARS INTERNATIONAL CARRY-IN & LOCAL ON-SITENEWLINEWARRANTY",
                    "purchaseDate": "2023-11-03",
                    "purchaseValue": "1193",
                    "warrantyDueDate": "2026-11-03",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Govindarajulu Vijay",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-11-22",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-11-22",
                        "returnDate": "2023-11-22",
                    },
                    {
                        "user": "Govindarajulu Vijay",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-11-22",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB036",
                    "brand": "Lenovo",
                    "seNo": "PF1LDVNG",
                    "model": "ThinkPad E490S",
                    "description": "Bundle with Bag and Mouse (GLEC-NB036M)",
                    "purchaseDate": "2019-07-26",
                    "purchaseValue": "1499",
                    "warrantyDueDate": "2022-07-25",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Bora Srikanth",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2022-08-15",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-08-15",
                        "returnDate": "2022-08-15",
                    },
                    {
                        "user": "Bora Srikanth",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2022-08-15",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB020",
                    "brand": "Lenovo",
                    "seNo": "PF0R12EA",
                    "model": "ThinkPad E470",
                    "description": "Bundle with Bag and Mouse (GLEC-NB020M), disposed",
                    "purchaseDate": "2017-06-30",
                    "purchaseValue": "1199",
                    "warrantyDueDate": "2018-06-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Thennarasu Thenishkumar",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-04-05",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-04-05",
                        "returnDate": "2023-04-05",
                    },
                    {
                        "user": "Thennarasu Thenishkumar",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-04-05",
                        "returnDate": "",
                    }
                ])
            }, 
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB047",
                    "brand": "Asus",
                    "seNo": "KBNXCV15N140488",
                    "model": "Asus P1440FB-FA0090R",
                    "description": "Bundle with Bag and Mouse (GLEC-NB047M)",
                    "purchaseDate": "2020-02-19",
                    "purchaseValue": "1400",
                    "warrantyDueDate": "2023-02-18",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Kelly Yuen",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2021-03-08",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-03-08",
                        "returnDate": "2021-03-08",
                    },
                    {
                        "user": "Kelly Yuen",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2021-03-08",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB018",
                    "brand": "Lenovo",
                    "seNo": "PFOR14GJ",
                    "model": "ThinkPad E470",
                    "description": "Bundle with Bag and Mouse(GLEC-NB018M)",
                    "purchaseDate": "2017-07-09",
                    "purchaseValue": "1351",
                    "warrantyDueDate": "2018-07-09",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Bodanapu Venkata Sai",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-03-21",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-03-21",
                        "returnDate": "2023-03-21",
                    },
                    {
                        "user": "Bodanapu Venkata Sai",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-03-21",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB071",
                    "brand": "ASUS",
                    "seNo": "R7NXCV123068296",
                    "model": "ASUS B1402CVA-EB0124X",
                    "description": "ASUS B1402CVA-EB0124XNEWLINEP/NCOLON 90NX06W1-M004W0NEWLINEINTEL CORE I5-1335U, 1X16GB, 512GB PCIE SSD+TPM, UMA,NEWLINEWIN 11 PRO, 14INCH FHD 250NITS ANTI-GLARE DISPLAY, HDNEWLINEWEBCAM, WIFI 6, W/FINGERPRINT/BACKLIT KB, 1.49KGNEWLINES$1,193.00 S$1,193.00NEWLINE3 YEARS INTERNATIONAL CARRY-IN & LOCAL ON-SITENEWLINEWARRANTY",
                    "purchaseDate": "2023-11-03",
                    "purchaseValue": "1193",
                    "warrantyDueDate": "2024-11-03",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Arumugam Azhakar",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-11-22",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-11-22",
                        "returnDate": "2023-11-22",
                    },
                    {
                        "user": "Arumugam Azhakar",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-11-22",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB050",
                    "brand": "LENOVO",
                    "seNo": "PF24BM52",
                    "model": "Lenovo ThinkPad E14-IML",
                    "description": "Bundle with Bag and Mouse (GLEC-NB050M)",
                    "purchaseDate": "2021-02-02",
                    "purchaseValue": "1500",
                    "warrantyDueDate": "2022-02-02",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Leung Kwok Yan Patrick",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-08-10",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-08-10",
                        "returnDate": "2023-08-10",
                    },
                    {
                        "user": "Leung Kwok Yan Patrick",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-08-10",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Monitor",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-DT008",
                    "brand": "HP",
                    "seNo": "000",
                    "model": "HP Z24nf G2 23.8-inch",
                    "description": "",
                    "purchaseDate": "2019-05-09",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2020-05-09",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Leung Kwok Yan Patrick",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2024-02-23",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2024-02-23",
                        "returnDate": "2024-02-23",
                    },
                    {
                        "user": "Leung Kwok Yan Patrick",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2024-02-23",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB011",
                    "brand": "Acer",
                    "seNo": "NXV9VSG00643023CAE7600",
                    "model": "Travelmate P245-M-54204G50MT",
                    "description": "Bundle with Bag and Mouse (GLEC-NB011M)",
                    "purchaseDate": "2014-11-17",
                    "purchaseValue": "1150",
                    "warrantyDueDate": "2015-11-17",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Khalil Mohammed Ibrahim",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-03-23",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-03-23",
                        "returnDate": "2023-03-23",
                    },
                    {
                        "user": "Khalil Mohammed Ibrahim",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-03-23",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB049",
                    "brand": "Lenovo",
                    "seNo": "PF1PB0QV",
                    "model": "ThinkPad E490",
                    "description": "Bundle with Bag and Mouse (GLEC-NB049M)",
                    "purchaseDate": "2019-07-26",
                    "purchaseValue": "1199",
                    "warrantyDueDate": "2022-07-25",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Uddin Mohammad Wahid",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2021-09-02",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-09-02",
                        "returnDate": "2021-09-02",
                    },
                    {
                        "user": "Uddin Mohammad Wahid",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2021-09-02",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB054",
                    "brand": "ASUS",
                    "seNo": "LANXCV07A585427",
                    "model": "Asus AP2451FA-EK0888R",
                    "description": "Bundle with Bag and Mouse (GLEC-NB054M)",
                    "purchaseDate": "2021-02-08",
                    "purchaseValue": "1500",
                    "warrantyDueDate": "2024-02-07",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Miah Sumon",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-06",
                        "returnDate": "2023-12-06",
                    },
                    {
                        "user": "Miah Sumon",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-06",
                        "returnDate": "",
                    }
                ])
            }, 
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB019",
                    "brand": "Lenovo",
                    "seNo": "PF0R14JW",
                    "model": "ThinkPad E470",
                    "description": "Bundle with Bag and Mouse(GLEC-NB019M)",
                    "purchaseDate": "2017-06-30",
                    "purchaseValue": "1071",
                    "warrantyDueDate": "2020-06-29",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Shanta Md",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2022-07-08",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-07-08",
                        "returnDate": "2022-07-08",
                    },
                    {
                        "user": "Shanta Md",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2022-07-08",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB039",
                    "brand": "Lenovo",
                    "seNo": "PF-1PB86A",
                    "model": "ThinkPad E490",
                    "description": "Bundle with Bag and Mouse (GLEC-NB039M)",
                    "purchaseDate": "2019-08-01",
                    "purchaseValue": "01199",
                    "warrantyDueDate": "2020-08-01",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Uddin Mayen",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-11-10",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-11-10",
                        "returnDate": "2023-11-10",
                    },
                    {
                        "user": "Uddin Mayen",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-11-10",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB040",
                    "brand": "Lenovo",
                    "seNo": "PF-1PB86A",
                    "model": "ThinkPad E490",
                    "description": "Bundle with Bag and Mouse (GLEC-NB039M)",
                    "purchaseDate": "2019-08-01",
                    "purchaseValue": "1199",
                    "warrantyDueDate": "2020-08-01",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Vijayan Vinoth Kumar",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-11-10",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-11-10",
                        "returnDate": "2023-11-10",
                    },
                    {
                        "user": "Vijayan Vinoth Kumar",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-11-10",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB028",
                    "brand": "Lenovo",
                    "seNo": "000",
                    "model": "ThinkPad E480",
                    "description": "Bundle with Bag and Mouse (GLEC-NB028M)",
                    "purchaseDate": "2018-11-30",
                    "purchaseValue": "1199",
                    "warrantyDueDate": "2019-11-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Baskar Manojkumar",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-03-24",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-03-24",
                        "returnDate": "2023-03-24",
                    },
                    {
                        "user": "Baskar Manojkumar",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-03-24",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB051",
                    "brand": "LENOVO",
                    "seNo": "PF250J8J",
                    "model": "Lenovo ThinkPad E14-IML",
                    "description": "Bundle with Bag and Mouse (GLEC-NB051M)",
                    "purchaseDate": "2021-02-02",
                    "purchaseValue": "1500",
                    "warrantyDueDate": "2024-02-01",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Serrano Ferdinand Arzobal",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2021-03-08",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2021-03-08",
                        "returnDate": "2021-03-08",
                    },
                    {
                        "user": "Serrano Ferdinand Arzobal",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2021-03-08",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB015",
                    "brand": "LENOVO",
                    "seNo": "PF0ASC4Q",
                    "model": "ThinkPad E450",
                    "description": "Bundle with Bag and Mouse(GLEC-NB015M)",
                    "purchaseDate": "2016-02-29",
                    "purchaseValue": "1258",
                    "warrantyDueDate": "2017-03-01",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Dhaveethu Bai Edbin George",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-04-06",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-04-06",
                        "returnDate": "2023-04-06",
                    },
                    {
                        "user": "Dhaveethu Bai Edbin George",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-04-06",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Computer",
                "subCat": "Laptop",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-NB074",
                    "brand": "Asus",
                    "seNo": "R9NXCV09E07837E",
                    "model": "ASUS B1402CVA-EB0124X",
                    "description": "ASUS B1402CVA-EB0123XNEWLINEP/NCOLON 90NX06W1-M004V0NEWLINEINTEL CORE I7-1355U PROCESSORNEWLINE1X16GB, 512GB PCIE SSD+TPM,NEWLINEINTEL UMA, WIN 11 PRO,NEWLINE14INCH FHD 250NITS ANTI-GLARE DISPLAY, HD WEBCAM, WIFI 6NEWLINEW/FINGERPRINT/BACKLIT KB,NEWLINEWEIGHTCOLON 1.49KGNEWLINE3 YEARS INTERNATIONAL CARRY-IN & LOCAL ON-SITENEWLINEWARRANTY",
                    "purchaseDate": "2023-11-27",
                    "purchaseValue": "1383",
                    "warrantyDueDate": "2024-11-27",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Khine May Oo",
                    "issuer": "Lim Sock Peck",
                    "issueDate": "2023-12-18",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-12-18",
                        "returnDate": "2023-12-18",
                    },
                    {
                        "user": "Khine May Oo",
                        "issuer": "Lim Sock Peck",
                        "issueDate": "2023-12-18",
                        "returnDate": "",
                    }
                ])
            },
        ]
    )
}